// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_Sort.scss
// module id = 579
// module chunks = 24 41 88